import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as messagesActions from '../../../redux/messages/actions';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import MessageReceiversFilter from './messageReceiversFilter';
import submitForm from '../../../utils/submitForm';

class messages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      query: '',
      sortType: 'asc',
      sortBy: 'createdAt',
      itemsPerPage: 20,
      selectedCafeReservationDetailsId: props.location.messageId,
      filter: '',
    };
  }

  componentDidMount() {
    if (this.props.location.messageId) {
      this.sortTable(this.state.sortBy);
    } else {
      this.props.history.push('/messages');
    }
  }

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      console.log('sss', searchQuery);
      this.props.fetchAllMessageReceivers(this.state.selectedCafeReservationDetailsId, searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllMessageReceivers(this.state.selectedCafeReservationDetailsId, query);
    });
  };

  sortTable = query => {
    this.applySort(query);
  };

  applySort = query => {
    this.setState({ sortType: this.state.sortType === 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  render() {
    let {
      messageReceiversList = [],
      messageReceiversLoading,
      messageReceiversMessage,
      messageReceiversError,
      messageReceivers,
      messageReceiversFailed,
    } = this.props;

    let { totalRecords } = messages;

    let { currentPage, itemsPerPage } = this.state;

    return (
      <>
        <section className="page-header">
          <h3 className="p-3 text-right text-muted">{locales('titles.messageReceivers')}</h3>
          <div className="form-actions d-flex align-items-center">
            <Link to="/messages" className="btn btn-default">
              <i className="fa fa-reply"/>
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <Spin spinning={messageReceiversLoading}>
          {messageReceiversError && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {messageReceiversFailed && <div className="alert alert-danger">{messageReceiversMessage}</div>}
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1"/>
            {locales('titles.messagesList')}
          </div>
          <div className="panel-body">
            <MessageReceiversFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort}/>
            <table className="table table-hover table-light table-striped">
              <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('userFullName')} className="text-center pointer">
                  <i name="userFullName" className="text-center align-middle text-muted px-1"/>
                  {locales('titles.FullName')}
                </th>
                <th onClick={() => this.sortTable('userMobileNumber')} className="text-center pointer">
                  <i name="userMobileNumber" className="text-center align-middle text-muted px-1"/>
                  {locales('titles.userMobileNumber')}
                </th>
              </tr>
              </thead>
              <tbody>
              {messageReceiversList.length ? (
                messageReceiversList.map((message, index) => (
                  <tr key={message.userId}>
                    <td className="text-center">{index + 1 + itemsPerPage * currentPage}</td>
                    <td
                      onClick={() =>
                        this.props.history.push({
                          pathname: '/users/details',
                          state: { id: message.userId },
                        })
                      }
                      className="text-center pointer btn-link"
                    >
                      {message.userFullName}
                    </td>
                    <td className="text-center">{message.userMobileNumber}</td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
              </tbody>
            </table>

            <footer className="col-12 d-flex justify-content-center py-2">
              <div className="pagination-container">
                <Pagination2
                  totalRecords={totalRecords || 0}
                  pageLimit={itemsPerPage}
                  pageNeighbours={2}
                  onPageChanged={this.onPageChanged}
                  currentPage={this.state.currentPage}
                />
              </div>
            </footer>
          </div>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    messageReceiversList: state.messagesReducer.messageReceiversList,
    messageReceiversMessages: state.messagesReducer.messageReceiversMessages,
    messageReceiversLoading: state.messagesReducer.messageReceiversLoading,
    messageReceiversError: state.messagesReducer.messageReceiversError,
    messageReceivers: state.messagesReducer.messageReceivers,
    messageReceiversFailed: state.messagesReducer.messageReceiversFailed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllMessageReceivers: (id, query) => dispatch(messagesActions.fetchAllMessageReceivers(id, query)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(messages));
